{
  "version": 1,
  "asset_id": "47f687d4-c344-4747-9a5e-f8e3012d29e6",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/47f687d4-c344-4747-9a5e-f8e3012d29e6/umair-320.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/47f687d4-c344-4747-9a5e-f8e3012d29e6/umair-320.webp",
  "original_filename": "umair-320.webp",
  "size": 5860,
  "content_type": "image/webp",
  "created_at": "2026-08-02T02:38:13Z"
}
